import useEvent from './useEvent';

const useKeypress = (key, callback = () => {}) =>
	useEvent('keydown', e => (e.keyCode && e.keyCode === key ? callback() : null));

export default useKeypress;
